import { render, staticRenderFns } from "./options.vue?vue&type=template&id=98709b6e&scoped=true&"
import script from "./options.vue?vue&type=script&lang=js&"
export * from "./options.vue?vue&type=script&lang=js&"
import style0 from "./options.vue?vue&type=style&index=0&id=98709b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98709b6e",
  null
  
)

export default component.exports